import React from 'react';
import CheckboxField from '@react/Common/CheckboxField/CheckboxField';

interface ToggleAllStateProps {
  isDisabled: boolean;
  isChecked: boolean;
  isFiltered: boolean;
}

interface ToggleAllDispatchProps {
  toggleAll: () => void;
}

type ToggleAllProps = ToggleAllStateProps & ToggleAllDispatchProps;

export const ToggleAllComponent: React.FC<ToggleAllProps> = ({ isFiltered, isDisabled, isChecked, toggleAll }) => {
  let label;

  if (!isChecked && !isFiltered) {
    label = t('action.enable.all');
  } else if (!isChecked && isFiltered) {
    label = t('action.enable.filtered');
  } else if (isChecked && !isFiltered) {
    label = t('action.disable.all');
  } else if (isChecked && isFiltered) {
    label = t('action.disable.filtered');
  }

  return (
    <CheckboxField
      id="toggle-all"
      name="toggle-all"
      label={label}
      value={isChecked}
      disabled={isDisabled}
      onChange={toggleAll}
    />
  );
};
